import { ApiBooking } from '@ibe/api';
import AnalyticsBase from './AnalyticsBase';
import SearchDetailEvent from './SearchDetailEvent';

class RouteBookingEvent extends AnalyticsBase {
  pathname: string;

  search: string;

  booking?: ApiBooking = undefined;

  details?: Partial<SearchDetailEvent>;

  isBookable?: boolean;
}

export default RouteBookingEvent;
